export const getRequesedInfo = state => state.legend.get('requesed')
export const getDate = state => state.legend.get('data')
export const getFetching = state => state.legend.get('fetching')
export const getError = state => state.legend.get('error')
